export class Option {
  id: string;
  value: string;
  default?: boolean;
}
